<div class="flex gap-3">
  <app-button2
    data-testid="btn-accept"
    class="min-w-[96px]"
    size="m"
    [appearance]="isAccepted() ? 'primary' : 'secondary'"
    [disabled]="loading()"
    (click)="onReply(InvitationAcceptStatus.ACCEPTED)"
    >Yes</app-button2
  >

  <app-button2
    data-testid="btn-maybe"
    class="min-w-[96px]"
    size="m"
    [appearance]="isTentative() ? 'primary' : 'secondary'"
    [disabled]="loading()"
    (click)="onReply(InvitationAcceptStatus.TENTATIVE)"
    >Maybe</app-button2
  >

  <app-button2
    data-testid="btn-decline"
    class="min-w-[96px]"
    size="m"
    [appearance]="isDeclined() ? 'primary' : 'secondary'"
    [disabled]="loading()"
    (click)="onReply(InvitationAcceptStatus.REJECTED)"
    >No</app-button2
  >
</div>
